import React, { useId } from 'react';

// The bundled ihsanone-logo.png asset is a near-white watermark that's invisible
// on white headers, so the mark everyone sees is drawn here instead: a rub el hizb
// (eight-point star) framing a heart — charity held inside a familiar Islamic
// geometry. Drawn as inline SVG so it stays crisp at every size and needs no asset.
const SIZES = {
  sm: 'h-6 w-6',
  md: 'h-9 w-9',
  lg: 'h-12 w-12'
};

const HEART_PATH =
  'M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.29 1.51 4.04 3 5.5l7 7Z';

export default function AppLogo({ size = 'md', className = '' }) {
  // useId keeps the gradient ids unique when several logos render on one page.
  const uid = useId().replace(/:/g, '');
  const bg = `logo-bg-${uid}`;
  const gloss = `logo-gloss-${uid}`;

  return (
    <svg
      viewBox="0 0 48 48"
      role="img"
      aria-label="IhsanOne logo"
      data-testid="app-logo"
      className={`flex-shrink-0 ${SIZES[size] || SIZES.md} ${className}`}
    >
      <defs>
        <linearGradient id={bg} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2DD4BF" />
          <stop offset="52%" stopColor="#0F9488" />
          <stop offset="100%" stopColor="#065F46" />
        </linearGradient>
        <linearGradient id={gloss} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.30" />
          <stop offset="55%" stopColor="#FFFFFF" stopOpacity="0" />
        </linearGradient>
      </defs>

      <rect width="48" height="48" rx="13" fill={`url(#${bg})`} />
      <rect width="48" height="48" rx="13" fill={`url(#${gloss})`} />

      {/* Rub el hizb: two squares offset by 45 degrees */}
      <g fill="none" stroke="#FFFFFF" strokeWidth="1.5" strokeLinejoin="round">
        <rect x="10" y="10" width="28" height="28" rx="3.5" strokeOpacity="0.5" />
        <rect
          x="10"
          y="10"
          width="28"
          height="28"
          rx="3.5"
          strokeOpacity="0.72"
          transform="rotate(45 24 24)"
        />
      </g>

      <g transform="translate(15.6 15.8) scale(0.7)">
        <path d={HEART_PATH} fill="#FFFFFF" />
      </g>
    </svg>
  );
}
